/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const ArrowCaretDownMd = ({ className }) => {
  return (
    <svg
      className={`arrow-caret-down-md ${className}`}
      fill="none"
      height="32"
      viewBox="0 0 33 32"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M21.7837 13.3333L16.4504 18.6666L11.1171 13.3333"
        stroke="#A8A8A8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
